// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"88":"164cb10c","288":"4be3c443","364":"6cc70c95","772":"75254090"}[chunkId] + ".js";
};